import type { RootState } from 'app/store';
import { HYDRATABLE_SLICES } from 'data/error-log-constants';
import { ReduxSnapshotType } from 'types/error-log';

export const mergeHydratableSlices = (
  state: RootState,
  slices: ReduxSnapshotType['slices']
): RootState => {
  const next = { ...state };
  const writableSlices = next as unknown as Record<string, unknown>;
  HYDRATABLE_SLICES.forEach((key) => {
    if (key in slices) {
      writableSlices[key] = slices[key];
    }
  });
  return next;
};
